import React from 'react'
import Blog3Img1 from '../assets/images/blog/blog3-img1.jpg'
import Blog3Img2 from '../assets/images/blog/blog3-img2.jpg'
import Blog3Img3 from '../assets/images/blog/blog3-img3.jpg'
import Blog3Img4 from '../assets/images/blog/blog3-img4.jpg'
import Blog3Img5 from '../assets/images/blog/blog3-img5.jpg'
import Blog3Img6 from '../assets/images/blog/blog3-img6.jpg'
import ClientsSaySlider from '../component/ClientsSaySlider'
import Loader from '../component/Loader'
import FixHeader from '../component/FixHeader'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom'


const Blog3 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="blog-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Blog</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Blog3")}>Blog</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/Blog3")}>Blog 3</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two">
                <div className="container">
                    <h2 className="d-none">hidden</h2>
                    <div className="list-blog-main" data-aos="fade-up">
                        <img src={Blog3Img1} alt="blog-page2-img1" />
                        <div>
                            <div className="design-date">
                                <p>December 2, 2023</p>
                            </div>
                            <p className="steps">How do you improve your content writing skills?</p>
                            <p className="pursuing">Are you passionate about design and interested in pursuing a career as a graphic designer? about design and interested in pursuing a career as a graphic designer Graphic design is a dynamic..
                            </p>
                            <div>
                                <div onClick={() => navigate("/BlogDetails1")} className="button button1" data-text="Read More">
                                    <span>Read More</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="list-blog-main" data-aos="fade-up">
                        <img src={Blog3Img2} alt="blog-page2-img1" />
                        <div>
                            <div className="design-date">
                                <p>December 2, 2023</p>
                            </div>
                            <p className="steps">Do you want to become an professional writer?</p>
                            <p className="pursuing">Are you passionate about design and interested in pursuing a career as a graphic designer? about design and interested in pursuing a career as a graphic designer Graphic design is a dynamic..
                            </p>
                            <div>
                                <div onClick={() => navigate("/BlogDetails2")} className="button button1" data-text="Read More">
                                    <span>Read More</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="list-blog-main" data-aos="fade-up">
                        <img src={Blog3Img3} alt="blog-page2-img1" />
                        <div>
                            <div className="design-date">
                                <p>December 2, 2023</p>
                            </div>
                            <p className="steps">Strengthen the foundations to scale to your skills</p>
                            <p className="pursuing">Are you passionate about design and interested in pursuing a career as a graphic designer? about design and interested in pursuing a career as a graphic designer Graphic design is a dynamic..
                            </p>
                            <div>
                                <div onClick={() => navigate("/BlogDetails3")} className="button button1" data-text="Read More">
                                    <span>Read More</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="list-blog-main" data-aos="fade-up">
                        <img src={Blog3Img4} alt="blog-page2-img1" />
                        <div>
                            <div className="design-date">
                                <p>December 2, 2023</p>
                            </div>
                            <p className="steps">Creating A Successful Blog For Your eCommerce</p>
                            <p className="pursuing">Are you passionate about design and interested in pursuing a career as a
                                graphic designer? about design and interested in pursuing a career as a graphic designer
                                Graphic design is a dynamic..
                            </p>
                            <div>
                                <div onClick={() => navigate("/BlogDetails1")} className="button button1" data-text="Read More">
                                    <span>Read More</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="list-blog-main" data-aos="fade-up">
                        <img src={Blog3Img5} alt="blog-page2-img1" />
                        <div>
                            <div className="design-date">
                                <p>December 2, 2023</p>
                            </div>
                            <p className="steps">How to Optimize Content for SEO : A Quick Guide</p>
                            <p className="pursuing">Are you passionate about design and interested in pursuing a career as a
                                graphic designer? about design and interested in pursuing a career as a graphic designer
                                Graphic design is a dynamic..
                            </p>
                            <div>
                                <div onClick={() => navigate("/BlogDetails2")} className="button button1" data-text="Read More">
                                    <span>Read More</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="list-blog-main" data-aos="fade-up">
                        <img src={Blog3Img6} alt="blog-page2-img1" />
                        <div>
                            <div className="design-date">
                                <p>December 2, 2023</p>
                            </div>
                            <p className="steps">How To Create Retail Copywriting That Gets Results</p>
                            <p className="pursuing">Are you passionate about design and interested in pursuing a career as a
                                graphic designer? about design and interested in pursuing a career as a graphic designer
                                Graphic design is a dynamic..
                            </p>
                            <div>
                                <div onClick={() => navigate("/BlogDetails3")} className="button button1" data-text="Read More">
                                    <span>Read More</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ClientsSaySlider />
            {/* <!-- ====================================== About Section Five ===================================== --> */}
            <section className="about-section-five">
                <div className="container">
                    <h2 className="section-heading-text best-solutions" data-aos="fade-up">Trust Me to deliver the <span>best
                        solutions</span> tailored to your needs.</h2>
                    <p className="sitamet-text nemo-text" data-aos="fade-up">Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Temporibus, iusto, quia neque amet saepe?</p>
                    <div className="subscribe-input-main" data-aos="fade-up">
                        <input type="text" placeholder="Enter Your Email" name='EntEmail' />
                        <div className="button btn-subscribe" data-text="Subscribe">
                            <span>Subscribe</span>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Blog3